export interface FontSizes {
    lg: any;
    sm: any;
    smd: any;
    default: any;
    md: any;
    xxl: any;
    xs: any;
}

export const fontSizes: FontSizes = {
    lg: 20,
    sm: 13,
    xs: 11,
    smd: 14,
    default: 16,
    md: 18,
    xxl: 35,
};
